// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvutpp{padding-left:var(--ds-space-150,9pt)}\n._1bsb1osq{width:100%}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._u5f3utpp{padding-right:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
